import {Injectable} from '@angular/core';
import {Subject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DynamicBarService {

    private subject = new Subject<any>();

    constructor() {
    }

    setBarra(tipo, inputs?) {
        this.subject.next({setComponent: true, tipo, inputs});
    }

    getDynamicBarObservable(): Observable<any> {
        return this.subject.asObservable();
    }
}
